import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaClassesLayer from "../components/ListaClassesLayer";
import { useTranslation } from "../i18n/I18nContext";
import { getClassesLabels } from "../utils/classesLabels";

const ListaClassesPage = () => {
  const { t } = useTranslation();
  const labels = getClassesLabels();
  return (
    <MasterLayout>
      <Breadcrumb title={t(labels.submenu)} />
      <ListaClassesLayer />
    </MasterLayout>
  );
};

export default ListaClassesPage;
